import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
    width: 100%;
    background-color: ${props => (props.backgroundColor) ? props.backgroundColor : 'none' };
    box-shadow: -3px 4px 11px 0px rgba(0, 0, 0, 0.07);
    max-width: 350px;
    border: solid ${props => (props.borderColor) ? props.borderColor : '#f10f0f' } 2px; 
    border-radius: 3px;
`;

const OuterBarChartContainer = ({ style, children, ...rest }) => (
    <StyledDiv style = {style} {...rest} >
        { children }
    </StyledDiv>
)

export default OuterBarChartContainer



// WEBPACK FOOTER //
// ./src/js/components/DataVisualization/PercentBarChart/OuterBarChartContainer.jsx